import { Text, VisuallyHidden } from '@chakra-ui/react';
import { Link } from '@time-line/components/common';
import { TrueMed } from '@time-line/components/icons';

import { Item } from './Item';

interface TruemedProps {
  truemedUrl: string;
}

export function Truemed({ truemedUrl }: TruemedProps) {
  return (
    <Item isChecked>
      <Text size="detail">
        HSA/FSA eligible with <VisuallyHidden>TrueMed</VisuallyHidden>
        <TrueMed
          aria-hidden="true"
          width="unset"
          height="1em"
          pos="relative"
          top="-1px"
        />{' '}
        ·{' '}
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={truemedUrl}
          variant="unstyled"
          underline
        >
          Get pre-qualified
        </Link>
      </Text>
    </Item>
  );
}
